var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Question } from 'packages/form/entities/legacy/question/Question';
import { DateUtility } from 'packages/utilities/DateUtility';
// Components
import Icon from 'common/UIToolKit/Icon.vue';
import UiCheckbox from 'ui/v1/controls/UiCheckbox.vue';
import UiRadioButton from 'ui/v1/controls/UiRadioButton.vue';
import UiTextButton from 'ui/v1/controls/UiTextButton.vue';
var DeprecatedResponseAnswer = /** @class */ (function (_super) {
    __extends(DeprecatedResponseAnswer, _super);
    function DeprecatedResponseAnswer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(DeprecatedResponseAnswer.prototype, "answer", {
        get: function () {
            return this.question.answer;
        },
        enumerable: false,
        configurable: true
    });
    DeprecatedResponseAnswer.prototype.formatDate = function (dateString) {
        return new DateUtility(dateString).format();
    };
    DeprecatedResponseAnswer.prototype.optionSelected = function (label) {
        return !!this.question.answer.find(function (answer) { return answer.answer === label; });
    };
    DeprecatedResponseAnswer.prototype.openInBlank = function (path) {
        window.open(path, '_blank');
    };
    var _a;
    __decorate([
        Prop({ default: null }),
        __metadata("design:type", typeof (_a = typeof Question !== "undefined" && Question) === "function" ? _a : Object)
    ], DeprecatedResponseAnswer.prototype, "question", void 0);
    DeprecatedResponseAnswer = __decorate([
        Component({
            components: {
                UiTextButton: UiTextButton,
                UiCheckbox: UiCheckbox,
                UiRadioButton: UiRadioButton,
                Icon: Icon,
            },
        })
    ], DeprecatedResponseAnswer);
    return DeprecatedResponseAnswer;
}(Vue));
export default DeprecatedResponseAnswer;
